import { render, staticRenderFns } from "./FavoritosView.vue?vue&type=template&id=0ac496b6&scoped=true&"
import script from "./FavoritosView.vue?vue&type=script&lang=js&"
export * from "./FavoritosView.vue?vue&type=script&lang=js&"
import style0 from "./FavoritosView.vue?vue&type=style&index=0&id=0ac496b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac496b6",
  null
  
)

export default component.exports